var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "intl-footer" }, [
    _c("div", { staticClass: "intl-footer__inner" }, [
      _c("div", { staticClass: "intl-footer__left" }, [
        _c("span", { staticClass: "intl-footer__title" }, [
          _vm._v(_vm._s(_vm.$t("footer.text"))),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "intl-footer__sub" }, [
          _vm._v(_vm._s(_vm.$t("footer.subtext"))),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "intl-footer__right" }, [
      _c("span", [_vm._v("© 2026 Beijing International Vocational Education")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }